/* eslint-disable no-case-declarations */
/* eslint-disable indent */
/* eslint-disable camelcase */
import store from '../../store'
import { roadwayVariables } from '../config/generalInputs.config'
import { LIGHTING_VALUES } from '../constants/pedestrian'
import { NO } from '../constants/roadwayVariables'
import {
  HIGH_CAPACITY_TRANSIT_FACILITY,
  HIGH_CAPACITY_TRANSIT_FACILITY_VALUES,
  TRANSIT_STOP_AMENITIES,
  TRANSIT_STOP_AMENITIES_VALUES
} from '../constants/transit'
import { setPedestrianInputs } from '../slices/criteriaSelection/pedestrian'
import {
  setTransitInputs,
  removeTransitStopAmenitiesInput
} from '../slices/criteriaSelection/transit'

export function setTransitSegmentInput() {
  const { transit, pedestrian, street, roadwayVariables, modalTiers } =
    store.getState()
  const { Transit: TTier } = modalTiers
  const { lighting } = pedestrian
  const { transit_stop_amenities } = transit
  const { high_capacity_transit } = roadwayVariables
  const { segments } = street

  // If Transit Tier is 0 or NA , do not change inputs
  if (TTier === 0) {
    return
  }

  for (const key of Object.keys(transit)) {
    switch (key) {
      case TRANSIT_STOP_AMENITIES:
        // Check transit shelter
        // eslint-disable-next-line no-case-declarations
        // const transitShelterArr = segments.filter(
        //   (segment) => segment?.type === 'transit-shelter'
        // )
        // // Get drive Lanes elevation
        // const driveLaneElevation = segments.find(
        //   (segment) => segment?.type === 'drive-lane'
        // )?.elevation

        // // Check if transit shelter is raised
        // const isRaised =
        //   transitShelterArr.length &&
        //   transitShelterArr.every(
        //     (shelter) => shelter?.elevation > driveLaneElevation
        //   )

        // if (transitShelterArr.length && !isRaised) {
        //   //  dispatchTransitStopInputs(0)
        //   dispatchTransitStopInputs(1)
        //   // !transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[7]) &&
        //   //   dispatchTransitStopInputs(7)
        // } else if (!transitShelterArr.length) {
        //   removeTransitStopInputs(1)
        //   // removeTransitStopInputs(0)

        //   // removeTransitStopInputs(7)
        // }

        // Check if there is a lamp
        // If no sidewalk , do not select any option for comfort zone width
        // if (
        //   segments.some((segment) => segment?.type.includes('lamp')) === true
        // ) {
        //   dispatchTransitStopInputs(2)
        // } else {
        //   // No Lighting
        //   removeTransitStopInputs(2)
        //   // Remove pedestrian lighting as well
        //   // No Lighting
        //   store.dispatch(
        //     setPedestrianInputs({
        //       field: key,
        //       value: LIGHTING_VALUES[2]
        //     })
        //   )
        // }

        // if (isRaised) {
        //   dispatchTransitStopInputs(5)
        // } else if (!isRaised) {
        //   removeTransitStopInputs(5)
        // }

        // Check for Bench
        // const benchArr = segments.filter(
        //   (segment) => segment?.type === 'sidewalk-bench'
        // )
        // if (benchArr.length) {
        //   dispatchTransitStopInputs(7)
        // } else if (!benchArr.length) {
        //   removeTransitStopInputs(7)
        // }

        // // Check for Bike rack
        // const bikeRackArr = segments.filter(
        //   (segment) => segment?.type === 'sidewalk-bike-rack'
        // )
        // if (bikeRackArr.length) {
        //   dispatchTransitStopInputs(8)
        // } else if (!bikeRackArr.length) {
        //   removeTransitStopInputs(8)
        // }

        break
      case HIGH_CAPACITY_TRANSIT_FACILITY:
        // Check for Transit lanes
        const transitLaneArr = segments.filter(
          (segment) => segment?.type === 'bus-lane'
        )

        // Check for Rapid Transit lanes
        const rapidTransitLaneArr = segments.filter(
          (segment) => segment?.type === 'brt-lane'
        )

        // if both standard bus lane and rapid bus lane exsist, consider only rapid bus lane

        if (rapidTransitLaneArr.length) {
          // // Check for variant string with copy
          // const rapidtransitLaneArrCopy = segments.filter(
          //   (segment) =>
          //     segment?.type === 'bus-lane' &&
          //     segment?.variantString?.includes('copy')
          // )
          // Check if its Two way
          const isTwoWay = ['outbound', 'inbound'].every((direction) =>
            rapidTransitLaneArr.some((lane) =>
              lane?.variantString?.includes(direction)
            )
          )

          // Transit lane indexes
          const rapidTransitLaneIndexes = rapidTransitLaneArr.map(
            (transitLane) =>
              segments.findIndex((segment) => segment?.id === transitLane?.id)
          )
          // Get the number of lanes to left and right of the transit lane
          const noOfLanesLeft = segments.filter(
            (lane, laneIndex) =>
              laneIndex < rapidTransitLaneIndexes[0] &&
              lane?.type?.includes('drive-lane')
          ).length

          const noOfLanesRight = segments.filter(
            (lane, laneIndex) =>
              laneIndex > rapidTransitLaneIndexes[1] &&
              lane?.type?.includes('drive-lane')
          ).length
          const noOfLanes = segments.map((segment) =>
            segment?.type.includes('lane')
          ).length

          // Check if the lanes are next to each other
          const isNextToEachOther =
            rapidTransitLaneIndexes[0] + 1 === rapidTransitLaneIndexes[1]

          // If high capacity transit in screen 1 is NO, then do not allow users to add transit segmetns
          if (high_capacity_transit === NO) {
            store.dispatch(
              setTransitInputs({
                field: HIGH_CAPACITY_TRANSIT_FACILITY,
                value: HIGH_CAPACITY_TRANSIT_FACILITY_VALUES[3]
              })
            )
            return
          }

          if (
            isTwoWay &&
            noOfLanesLeft === noOfLanesRight &&
            noOfLanes > 2 &&
            isNextToEachOther
          ) {
            dispatchHightCapacityInputs(0)
          } else if (rapidTransitLaneArr.length && !isNextToEachOther) {
            dispatchHightCapacityInputs(1)
          } else if (!transitLaneArr.length) {
            dispatchHightCapacityInputs(3)
          } else {
            dispatchHightCapacityInputs('')
          }
        } else {
          // Check for variant string with copy
          const transitLaneArrCopy = segments.filter(
            (segment) =>
              segment?.type === 'bus-lane' &&
              segment?.variantString?.includes('copy')
          )
          // Check if its Two way
          const isTwoWay = ['outbound', 'inbound'].every((direction) =>
            transitLaneArr.some((lane) =>
              lane?.variantString?.includes(direction)
            )
          )

          // Transit lane indexes
          const transitLaneIndexes = transitLaneArr.map((transitLane) =>
            segments.findIndex((segment) => segment?.id === transitLane?.id)
          )
          // Get the number of lanes to left and right of the transit lane
          const noOfLanesLeft = segments.filter(
            (lane, laneIndex) =>
              laneIndex < transitLaneIndexes[0] &&
              lane?.type?.includes('drive-lane')
          ).length

          const noOfLanesRight = segments.filter(
            (lane, laneIndex) =>
              laneIndex > transitLaneIndexes[1] &&
              lane?.type?.includes('drive-lane')
          ).length
          const noOfLanes = segments.map((segment) =>
            segment?.type.includes('lane')
          ).length

          // Check if the lanes are next to each other
          const isNextToEachOther =
            transitLaneIndexes[0] + 1 === transitLaneIndexes[1]

          // If high capacity transit in screen 1 is NO, then do not allow users to add transit segmetns
          if (high_capacity_transit === NO) {
            store.dispatch(
              setTransitInputs({
                field: HIGH_CAPACITY_TRANSIT_FACILITY,
                value: HIGH_CAPACITY_TRANSIT_FACILITY_VALUES[3]
              })
            )
            return
          }

          if (
            isTwoWay &&
            noOfLanesLeft === noOfLanesRight &&
            noOfLanes > 2 &&
            isNextToEachOther
          ) {
            dispatchHightCapacityInputs(0)
          } else if (
            transitLaneArr.length &&
            !transitLaneArrCopy.length &&
            !isNextToEachOther
          ) {
            dispatchHightCapacityInputs(1)
          } else if (transitLaneArrCopy.length) {
            dispatchHightCapacityInputs(2)
          } else if (!transitLaneArr.length) {
            dispatchHightCapacityInputs(3)
          } else {
            dispatchHightCapacityInputs('')
          }
        }
        break
      default:
    }
  }
}

function dispatchTransitStopInputs(input) {
  store.dispatch(
    setTransitInputs({
      field: TRANSIT_STOP_AMENITIES,
      value: TRANSIT_STOP_AMENITIES_VALUES[input]
    })
  )
}

export function removeTransitStopInputs(input) {
  store.dispatch(
    removeTransitStopAmenitiesInput({
      value: TRANSIT_STOP_AMENITIES_VALUES[input]
    })
  )
}

function dispatchHightCapacityInputs(input) {
  store.dispatch(
    setTransitInputs({
      field: HIGH_CAPACITY_TRANSIT_FACILITY,
      value: HIGH_CAPACITY_TRANSIT_FACILITY_VALUES[input]
    })
  )
}
